<template>
    <el-select v-model="selectedFilter" placeholder="Select filter" @change="onFilterChange" class="mr5">
      <el-option label="All Channels" value="all"></el-option>
      <el-option label="Partnered Channels" value="partner"></el-option>
      <el-option label="Non-partnered Channels" value="non-partner"></el-option>
    </el-select>
  </template>
  
  <script>
  export default {
    data() {
      return {
        selectedFilter: 'all', // Default filter value
      };
    },
    methods: {
      onFilterChange(value) {
        this.$emit('filter-changed', value);  // Emit the selected filter to parent
      },
    },
  };
  </script>
  <style>

  </style>